module.exports = __webpack_public_path__ + "static/media/correct-choice.7e864110.wav";